// The public opening view already contains its data. Keep the existing Axios
// client/interceptors, but fetch that module only when a request is actually made.
// This deliberately exposes only the get/post interface used by these components.
export function createDeferredAxiosMixin(loadMixin = () => import('./VueMixins.js')) {
	return {
		data: () => ({ nrRequestsActive: 0, requestActive: false }),
		methods: {
			mixinAxios(funcPreRequest = null, funcPostRequest = null) {
				const owner = this;
				const custom = typeof funcPreRequest === 'function' && typeof funcPostRequest === 'function';
				let client;
				const request = (method, args) => {
					// Count the loading interval too, so a second click cannot queue an
					// extra purchase while the first request's module is downloading.
					if (custom) funcPreRequest();
					else { owner.nrRequestsActive++; owner.requestActive = true; }
					return Promise.resolve()
						.then(() => client ??= loadMixin().then(({ mixinAxios }) =>
							mixinAxios.methods.mixinAxios.call(owner, () => {}, () => {})))
						.then(http => http[method](...args))
						.finally(() => {
							if (custom) funcPostRequest();
							else { owner.nrRequestsActive--; owner.requestActive = false; }
						});
				};
				return {
					get: (...args) => request('get', args),
					post: (...args) => request('post', args)
				};
			}
		},
		computed: {
			requestsActive() { return this.nrRequestsActive > 0; }
		}
	};
}

export const mixinAxios = createDeferredAxiosMixin();
